<template>
  <f7-page>
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>{{ fullname }}</f7-nav-title>
      <f7-nav-right v-if="mode === 'selecting'">
        <f7-link @click.prevent="selected_messages = [], mode = 'chat'">Hủy chọn</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <input type="file" ref="files" accept="image/*" style="display: none;" v-on:change="sendImage">
    <f7-messagebar ref="messagebar" placeholder="Aa" :disabled="mode === 'selecting'">
      <f7-link icon-ios="f7:doc_on_doc" slot="inner-start" v-if="mode === 'selecting'" class="margin-right" @click.prevent="copySelectedMessages">
        Copy
      </f7-link>
      <f7-link icon-ios="f7:trash" slot="inner-start" v-if="mode === 'selecting'" class="margin-right" @click.prevent="removeSelectedMessages">
        Xóa
      </f7-link>
      <f7-link icon-ios="f7:arrowshape_turn_up_right" slot="inner-start" v-if="mode === 'selecting'" class="margin-right" @click.prevent="openPopupForward">
        Chuyển
      </f7-link>
      <f7-link
          v-if="mode !== 'selecting'"
          icon-ios="f7:camera_fill"
          icon-aurora="f7:camera_fill"
          icon-md="material:camera_alt"
          slot="inner-start"
          @click="$refs.files.click()"
      ></f7-link>
      <f7-link
          icon-ios="f7:arrow_up_circle_fill"
          icon-aurora="f7:arrow_up_circle_fill"
          icon-md="material:send"
          slot="inner-end"
          :color="mode === 'selecting' ? 'gray' : ''"
          @click="sendMessage"
      ></f7-link>
    </f7-messagebar>
    <f7-messages ref="messages" class="taphold-block">
      <f7-messages-title v-if="messagesFormatted.length === 0"><b>Chưa có dữ liệu!</b></f7-messages-title>
      <template v-for="(message, index) in messagesFormatted">
        <f7-messages-title :key="index" v-if="message.isTitle"><b>{{ message.text }}</b></f7-messages-title>
        <f7-message
            v-else
            :key="index"
            :type="message.type"
            :name="message.name"
            :footer="message.footer"
            :image="message.image"
            :text-footer="$moment(message.created_at).format('HH:mm')"
            :first="isFirstMessage(message, index)"
            :last="isLastMessage(message, index)"
            :tail="isTailMessage(message, index)"
            @taphold.native="openMessageActions(message)"
            @click="openPhoto(message.image)"
        >
          <span slot="text" v-if="message.text" v-html="(message.status === -1) ? `<s>${message.text}</s>` : message.text"></span>
          <template slot="avatar" v-if="mode === 'selecting'">
            <f7-checkbox :checked="_.findIndex(selected_messages, {id: message.id}) >= 0" @change="toggleCheckbox(message)"></f7-checkbox>
          </template>
        </f7-message>
      </template>
    </f7-messages>
    <f7-actions ref="actionsMessage">
      <f7-actions-group>
        <f7-actions-button color="black" @click="mode = 'selecting', selected_messages = [selecting_message]">
          Chọn
        </f7-actions-button>
        <f7-actions-button color="black" @click="$copyText(selecting_message.text.replace(/<br>/g, `\n`).trim())">
          Copy tin
        </f7-actions-button>
        <f7-actions-button color="black" @click="selected_messages = [selecting_message], openPopupForward()">
          Chuyển tiếp
        </f7-actions-button>
        <f7-actions-button color="red" @click="removeMessage" v-if="selecting_message.name === user_info.username">
          Xóa
        </f7-actions-button>
      </f7-actions-group>
    </f7-actions>
    <f7-photo-browser
        :photos="photos"
        popup-close-link-text="Đóng"
        type="popup"
        ref="popup"
    ></f7-photo-browser>
    <f7-list style="display: none">
      <f7-list-item :ref="`forward-${chatroom_key}`" smart-select :smart-select-params="{openIn: 'popup', pageTitle: 'Chọn người nhận', closeOnSelect: true, popupCloseLinkText: 'Đóng'}">
        <select @change="chooseForward($event.target.value)">
          <option v-for="(friend, idx) in friends" :key="idx" :value="friend.chatroom_key" :selected="friend.chatroom_key === chatroom_key">
            {{ friend.fullname }}
          </option>
        </select>
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>
<script>
import Echo from 'laravel-echo'
import {mapState} from 'vuex';

window.Pusher = require('pusher-js');

export default {
  props     :{
    username    :String,
    fullname    :String,
    chatroom_key:String
  },
  data(){
    return {
      typingMessage     :null,
      responseInProgress:false,
      mode              :"chat",
      messagesData      :[],
      selecting_message :{},
      selected_messages :[],
      photos            :[]
    }
  },
  computed:{
    ...mapState(['user_info', 'access_token', 'friends']),
    messagesFormatted(){
      let messages = [];
      let current_date = '';

      this._.each(this.messagesData, (item) => {
        if(this.$moment(item.created_at).format('DD/MM/YYYY') !== current_date){
          messages.push({
            isTitle:true,
            text   :this.$moment(item.created_at).format('DD/MM/YYYY')
          });
          current_date = this.$moment(item.created_at).format('DD/MM/YYYY');
        }

        messages.push({
          id        :item.chat_message_id,
          isTitle   :false,
          type      :(item.username === this.user_info.username) ? 'sent' : 'received',
          text      :(!this._.isEmpty(item.file_url) && item.status === 0) ? '' : item.message,
          name      :item.fullname,
          username  :item.username,
          image     :(!this._.isEmpty(item.file_url) && item.status === 0) ? item.file_url : null,
          footer    :item.footer,
          created_at:item.created_at,
          status    :item.status
        });
      });

      return messages;
    }
  },
  mounted(){
    const self = this;
    self.$f7ready(() => {
      self.messagebar = self.$refs.messagebar.f7Messagebar;
      self.messages = self.$refs.messages.f7Messages;

      self.getChatMessages();
    });

    window.Echo = new Echo({
      broadcaster :'pusher',
      key         :process.env.VUE_APP_PUSHER_KEY,
      cluster     :process.env.VUE_APP_PUSHER_CLUSTER,
      encrypted   :true,
      authEndpoint:process.env.VUE_APP_PUSHER_AUTH,
      auth        :{headers:{Authorization:"Bearer " + this.access_token}}
    });

    window.Echo.private('chat.' + this.chatroom_key)
        .listen('MessageSent', (e) => {
          if(e.user !== this.user_info.username){
            this.messagesData.push({
              chat_message_id:e.chat_message_id,
              message        :e.message,
              username       :e.user,
              fullname       :e.fullname,
              file_url       :(!this._.isEmpty(e.file_url)) ? e.file_url : null,
              created_at     :this.$moment().format('YYYY-MM-DD HH:mm:ss'),
              status         :0
            });
          }
        })
        .listen('MessageRemoved', (e) => {
          let idx = this._.findIndex(this.messagesData, {chat_message_id:e.chat_message_id});
          if(idx >= 0){
            this.messagesData[idx].status = -1;
          }
        });
  },
  destroyed(){
    window.Echo.leave('chat.' + this.chatroom_key);
  },
  methods:{
    isFirstMessage(message, index){
      const self = this;
      const previousMessage = self.messagesFormatted[index - 1];
      if(message.isTitle) return false;
      if(!previousMessage || previousMessage.type !== message.type || previousMessage.username !== message.username) return true;
      return false;
    },
    isLastMessage(message, index){
      if(this.mode === 'selecting'){
        return true;
      }
      const self = this;
      const nextMessage = self.messagesFormatted[index + 1];
      if(message.isTitle) return false;
      if(!nextMessage || nextMessage.type !== message.type || nextMessage.username !== message.username) return true;
      return false;
    },
    isTailMessage(message, index){
      const self = this;
      const nextMessage = self.messagesFormatted[index + 1];
      if(message.isTitle) return false;
      if(!nextMessage || nextMessage.type !== message.type || nextMessage.username !== message.username) return true;
      return false;
    },
    getChatMessages(){
      this.$store.dispatch('getChatMessages', {
        chatroom_key:this.chatroom_key,
        limit       :100
      })
          .then((data) => {
            this.messagesData = this._.reverse(data);
          })
          .catch((error) => {
            this.$f7.dialog.alert(error, 'LỖI!');
          })
    },
    sendMessage(){
      const self = this;
      const text = self.messagebar.getValue().replace(/\n/g, '<br>').trim();

      if(text.trim().length === 0){
        return false;
      }

      // Clear area
      self.messagebar.clear();
      // Focus area
      if(text.trim().length) self.messagebar.focus();

      let new_id = (new Date().valueOf());

      self.messagesData.push({
        chat_message_id:new_id,
        username       :this.user_info.username,
        fullname       :this.user_info.fullname,
        message        :text.trim(),
        footer         :'Đang gửi...',
        status         :0
      });

      this.$store.dispatch('postChatMessage', {
        message     :text.trim(),
        chatroom_key:this.chatroom_key
      })
          .then((data) => {
            let idx = this._.findIndex(self.messagesData, {chat_message_id:new_id});
            self.messagesData[idx].chat_message_id = data.data.chat_message_id;
            self.messagesData[idx].footer = '';
          })
          .catch((error) => {
            self.messagesData[self.messagesData.length - 1].footer = 'LỖI: ' + error;
          })
    },
    sendImage(){
      const self = this;

      self.messagebar.clear();
      self.messagebar.focus();

      let new_id = (new Date().valueOf());

      self.messagesData.push({
        chat_message_id:new_id,
        username       :this.user_info.username,
        fullname       :this.user_info.fullname,
        message        :'Ảnh đính kèm',
        file_url       :require('@/assets/img_placeholder.png'),
        footer         :'Đang tải lên...',
        status         :0
      });

      this.$store.dispatch('postChatImage', {
        message     :'Ảnh đính kèm',
        file        :self.$refs.files.files[0],
        chatroom_key:this.chatroom_key
      })
          .then((data) => {
            let idx = this._.findIndex(self.messagesData, {chat_message_id:new_id});
            self.messagesData[idx].chat_message_id = data.data.chat_message_id;
            self.messagesData[idx].file_url = data.data.file_url;
            self.messagesData[idx].footer = '';
          })
          .catch((error) => {
            self.messagesData[self.messagesData.length - 1].footer = 'LỖI: ' + error;
          })
    },
    openMessageActions(item){
      this.selecting_message = item;
      this.$refs.actionsMessage.open();
    },
    removeMessage(){
      this.$f7.preloader.show();
      this.$store.dispatch('removeChatMessage', {
        chat_message_id:this.selecting_message.id,
        chatroom_key   :this.chatroom_key
      })
          .then(() => {
            let idx = this._.findIndex(this.messagesData, {chat_message_id:this.selecting_message.id});
            if(idx >= 0){
              this.messagesData[idx].status = -1;
            }
            this.$f7.preloader.hide();
          })
          .catch((error) => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert(error, 'LỖI!');
          })
    },
    toggleCheckbox(message){
      let idx_checked = this._.findIndex(this.selected_messages, {id:message.id});
      if(idx_checked >= 0){
        this.selected_messages.splice(idx_checked, 1);
      }else{
        this.selected_messages.push(message);
      }
    },
    copySelectedMessages(){
      let content = '';
      this._.each(this._.orderBy(this.selected_messages, ['id'], ['asc']), (item) => {
        content += item.text.replace(/<br>/g, "\n") + "\n";
      });
      this.$copyText(content.trim());
      this.$f7.dialog.alert('', 'ĐÃ COPIED!');
      this.mode = 'chat';
    },
    removeSelectedMessages(){
      this.$f7.preloader.show();

      let ids = this.selected_messages.map((o) => {
        return o.id;
      })

      this.$store.dispatch('removeChatMessages', {
        chat_messages_id:ids,
        chatroom_key    :this.chatroom_key
      })
          .then(() => {
            this._.each(ids, (id) => {
              let idx = this._.findIndex(this.messagesData, {chat_message_id:id});
              if(idx >= 0 && this.messagesData[idx].username === this.user_info.username){
                this.messagesData[idx].status = -1;
              }
            })
            this.$f7.preloader.hide();
            this.$f7.dialog.alert('', 'ĐÃ XÓA!');
            this.mode = 'chat';
          })
          .catch((error) => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert(error, 'LỖI!');
          })
    },
    openPhoto(url){
      if(this._.isEmpty(url)){
        return false;
      }

      if(this.mode === 'selecting'){
        return false;
      }

      this.photos = [url];
      setTimeout(() => {
        this.$refs.popup.open();
      }, 50);
    },
    openPopupForward(){
      this.$refs[`forward-${this.chatroom_key}`].f7SmartSelect.open();
    },
    chooseForward(chatroom_key){
      const self = this;

      if(this.selected_messages.length <= 0){
        this.$f7.dialog.alert('Vui lòng chọn tin nhắn cần chuyển tiếp và thử lại!');
        return false
      }

      self.$f7.preloader.show();

      let promises = [];
      for(let i = 0 ; i < self.selected_messages.length ; i++){
        let promise_forward = self.$store.dispatch('postChatMessage', {
          message     :self.selected_messages[i].text.trim(),
          chatroom_key:chatroom_key
        });
        promises.push(promise_forward);
      }

      Promise.all(promises)
          .then(function(){
            self.$f7.preloader.hide();
            self.mode = 'chat';
            self.selected_messages = [];
            self.$f7.dialog.alert('Chuyển tiếp tin nhắn thành công!', 'THÔNG BÁO');
          })
          .catch(() => {
            self.$f7.preloader.hide();
            self.$f7.dialog.alert('Chuyển tiếp tin nhắn thất bại!', 'THÔNG BÁO');
          });
    }
  }
};
</script>
